import { addSchemaCommentHandler } from './AddCommentStmt';
import { removeSchemaCommentHandler } from './RemoveCommentStmt';
import { updateSchemaCommentHandler } from './UpdateSchemaCommentStmt';
export * from './AddCommentStmt';
export * from './RemoveCommentStmt';
export * from './UpdateSchemaCommentStmt';
export const schemaCommentHandlers = [addSchemaCommentHandler, removeSchemaCommentHandler, updateSchemaCommentHandler];
//# sourceMappingURL=index.js.map